module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n    " + _vm._s(_vm.item.first_name) + " " + _vm._s(_vm.item.last_name) + "\n  ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "color": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Anuluj")])], 1), _vm._v(" "), (_vm.item.id) ? _c('users-form', {
    attrs: {
      "item": _vm.item
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39bc38a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/Edit.vue
// module id = 245
// module chunks = 0